var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroDilutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.472656,
    y: 0.523438,
    width: 80,
    height: 80,
    rx: 22,
    fill: "#2F736E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4695_60313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 81
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.472656,
    y: 0.523438,
    width: 80,
    height: 80,
    rx: 22,
    fill: "#2F736E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4695_60313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-73.2529 69.543C-55.138 65.4746 -6.8884 57.7783 41.1907 57.7783C89.2698 57.7783 135.516 65.4746 152.629 69.543",
    stroke: "url(#paint0_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.7627 54.642C-38.3323 53.8577 25.0263 52.2891 43.0178 52.2891C61.0092 52.2891 124.112 53.8577 153.414 54.642",
    stroke: "url(#paint1_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.7627 42.877C-35.8285 43.9227 30.8119 46.0142 41.8994 46.0142C52.987 46.0142 120.862 43.9227 153.414 42.877",
    stroke: "url(#paint2_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.3315 31.1133C-45.029 34.4348 10.9691 38.9564 40.5407 38.9564C70.1124 38.9564 128.111 34.4348 153.414 31.1133",
    stroke: "url(#paint3_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.4688 20.916C-54.3538 24.8376 -6.10422 32.6807 41.9749 32.6807C90.054 32.6807 136.3 24.8376 153.414 20.916",
    stroke: "url(#paint4_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.2529 6.79883C-56.5126 13.3348 -10.1215 26.4067 41.5199 26.4067C93.1612 26.4067 137.633 13.3348 153.414 6.79883",
    stroke: "url(#paint5_linear_4695_60313)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1587,
    y: 16.209,
    width: 48.6275,
    height: 48.6275,
    rx: 24.3137,
    fill: "#4E8884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9824 30.1307L41.8313 27.3984C41.0901 27.1198 39.8809 27.1198 39.1398 27.3984L31.9886 30.1307C30.6104 30.6612 29.4922 32.3059 29.4922 33.8047V44.5483C29.4922 45.6227 30.1813 47.0419 31.0264 47.6786L38.1776 53.1299C39.4388 54.0982 41.5062 54.0982 42.7674 53.1299L49.9186 47.6786C50.7637 47.0286 51.4529 45.6227 51.4529 44.5483V33.8047C51.4659 32.3059 50.3477 30.6612 48.9824 30.1307Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4695_60313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8282 39.9515C45.6272 38.1791 45.6272 35.3056 43.8282 33.5333C42.0292 31.7609 39.1125 31.7609 37.3135 33.5333C35.5145 35.3056 35.5145 38.1791 37.3135 39.9515C37.7915 40.4224 38.3483 40.7681 38.9422 40.9888V49.044L40.5709 50.6485L42.1995 49.044L41.1138 47.9743L42.1995 46.9045L41.1138 45.8348L42.1995 44.7651L42.1995 40.9888C42.7934 40.7681 43.3503 40.4224 43.8282 39.9515Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5696 35.7081V38.0966",
    stroke: "#A3CACD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4695_60313",
    x1: -8.77232,
    y1: 63.6606,
    x2: 83.3428,
    y2: 63.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4695_60313",
    x1: -4.62544,
    y1: 53.4655,
    x2: 85.5706,
    y2: 53.4655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4695_60313",
    x1: -4.62544,
    y1: 44.4456,
    x2: 85.5706,
    y2: 44.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4695_60313",
    x1: -5.7465,
    y1: 35.0349,
    x2: 85.0893,
    y2: 35.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4695_60313",
    x1: -7.98815,
    y1: 26.7984,
    x2: 84.127,
    y2: 26.7984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4695_60313",
    x1: -2.27254,
    y1: 16.6027,
    x2: 86.3549,
    y2: 16.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204967,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81631,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4695_60313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white",
    transform: "translate(31.5703 31.6191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroDilutionIcon);
export default __webpack_public_path__ + "static/media/zero-dilution-icon.07aebfad0fb0bc976036ac24b4350739.svg";
export { ForwardRef as ReactComponent };